import { apiAxios } from '@/lib/apiAxios';
export const toggleEntryPoint = async (publicId) => apiAxios
    .patch(`/entry-points/${publicId}/toggle`)
    .then((response) => response.data);
export const patchEntryPointName = async ({ publicId, name }) => apiAxios
    .patch(`/entry-points/${publicId}/name`, { name })
    .then((response) => response.data);
export const patchEntryPointCustomSlug = async ({ publicId, customSlug, }) => apiAxios
    .patch(`/entry-points/${publicId}/custom-slug`, { customSlug })
    .then((response) => response.data);
/**
 * Probes whether a vanity slug can be claimed. `exclude` is the publicId of
 * the entry point already holding the slug, so an edit doesn't report the
 * entry point as colliding with itself.
 */
export const fetchCustomSlugAvailability = async ({ slug, exclude }) => apiAxios
    .get('/entry-points/custom-slug/availability', { params: { slug, exclude } })
    .then((response) => response.data);
export const deleteEntryPoint = async (publicId) => apiAxios
    .delete(`/entry-points/${publicId}`)
    .then((response) => response.data);
export const fetchQrCode = async ({ publicId, params, }) => apiAxios.get(`/entry-points/${publicId}/qr-code`, { params }).then((response) => response.data);
